export const ComponentsStrings = {
  payloadProperty: {
    required: 'required',
    format: 'format:',
    enum: 'enum:',
    example: 'example:',
    comment: 'comment:',
  },
}
